import { FC } from 'react'
import { searchSuggestionTerms } from '../../components/Search/search-utils'
import { Trans, useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import Link from '@mui/material/Link'
import { RouteUtils } from '../../utils/route-utils'
import { OptionalBreak } from '../OptionalBreak'
import { SearchScope } from '../../../types/searchScope'

interface Props {
  scope: SearchScope | undefined
}

export const SearchSuggestionsLinks: FC<Props> = ({ scope }) => {
  const { t } = useTranslation()
  const { suggestedBlock, suggestedTransaction, suggestedAccount, suggestedTokenFragment } =
    (scope?.network && scope?.layer && searchSuggestionTerms[scope.network][scope.layer]) ??
    searchSuggestionTerms['mainnet']['sapphire']!

  return (
    <Trans
      t={t}
      i18nKey="search.searchSuggestions"
      components={{
        OptionalBreak: <OptionalBreak />,
        BlockIcon: <></>,
        BlockLink: <Link component={RouterLink} to={RouteUtils.getSearchRoute(scope, suggestedBlock)} />,
        TransactionIcon: <></>,
        TransactionLink: (
          <Link component={RouterLink} to={RouteUtils.getSearchRoute(scope, suggestedTransaction)} />
        ),
        AccountIcon: <></>,
        AccountLink: <Link component={RouterLink} to={RouteUtils.getSearchRoute(scope, suggestedAccount)} />,
        TokenIcon: <></>,
        TokenLink: (
          <Link component={RouterLink} to={RouteUtils.getSearchRoute(scope, suggestedTokenFragment)} />
        ),
      }}
    />
  )
}
